import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import trafficSigns from "../../data2/categorys/AR/trafficSigns"
export default function TrafficSigns() {
  const [item, setItem] = useState()
  const [safetyD,setSafety]= useState()
  useEffect(() => {

    function shuffle(array) {
      
      array.sort(() => Math.random() - 0.5);
      return array
    }
    
    if(safetyD)
    {setItem(shuffle(safetyD).slice(0, 5))}
  }, [safetyD])



  useEffect(() => {
    let newItems = []
    if (trafficSigns) {

      trafficSigns.map((item) => {
        // console.log("item is : ", item)
        let newItem = item
        // console.log("descr",(newItem.description))
        newItem.description.__cdata = item.description.__cdata.toString().replace("correctAnswer.style.background='red'", "correctAnswer.style.background='#e24e29',correctAnswer.style.opacity='0.9' ")
        newItem.description.__cdata = item.description.__cdata.toString().replace('style="float: left;"','style="display: none;"')
        newItem.description.__cdata  = item.description.__cdata.toString().replace('اظهار الا جابة الصحيحة','اظهار الاجابة الصحيحة')
        // console.log("new item is : ", newItem)
        newItems.push(newItem)

      })
      // console.log("new items array:", newItems)
      let x = newItems
      setSafety(x)
    }
    // setItem(newItems)
  }, [ trafficSigns])

  return (
    <div className="container careers" dir="rtl">
      {item && item.map((it, i) => {
        return (
          <Link to='' key={i} >

            <h3 className="question"> {i + 1} -  {it.title}</h3>
            {/* <br></br>
            <br></br>
            <p></p> */}
            <div className="answers" dangerouslySetInnerHTML={{ __html: it.description.__cdata }} />
          </Link>
        )
      })}
      <button onClick={() => {window.location.reload() ; window.scrollTo({ top: 0, behavior: 'smooth' });}}> تحديث</button>
    </div>


  )
}
  